import { Phone, MapPin } from "lucide-react";
import { images, restaurant } from "../lib/data";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden text-[#f9f6f0]"
    >
      {/* Image */}
      <div className="absolute inset-0">
        <img
          src={images.hero}
          alt="Mediterranean grilled feast at The Greek Yum Yum's"
          className="kenburns absolute inset-0 h-full w-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#2c3528]/65 via-[#2c3528]/35 to-[#2c3528]/85" />
        <div className="absolute inset-0 grain opacity-50" />
      </div>

      {/* Top meta strip */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 pt-28 md:pt-32 flex items-center justify-between text-[11px] md:text-xs tracking-[0.28em] uppercase text-[#f9f6f0]/80">
        <span className="hidden sm:inline">Est. 2010 · Zakynthos</span>
        <span className="hidden sm:inline">Family-run since day one</span>
        <span>Open today · 11:00 – 00:30</span>
      </div>

      {/* Main copy */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 pt-16 md:pt-24 lg:pt-28">
        <p className="overline text-[#e8d8b8]" data-testid="hero-overline">
          A Traditional Greek Taverna
        </p>
        <h1
          data-testid="hero-headline"
          className="font-serif-display mt-6 text-[15vw] sm:text-[12vw] md:text-[9.5vw] lg:text-[8.5vw] leading-[0.92] tracking-[-0.025em] text-[#faf3e2]"
        >
          The Greek
          <br />
          <span className="italic font-light text-[#f1c98a]">
            Yum Yum&rsquo;s
          </span>
        </h1>

        <div className="mt-10 max-w-xl">
          <p className="text-lg md:text-xl leading-relaxed text-[#f9f6f0]/85">
            Slow-cooked lamb, char-grilled souvlaki and recipes carried for
            fifteen summers in Planos&nbsp;Tsilivi. Pull up a chair — dinner is
            already on the fire.
          </p>
        </div>

        <div className="mt-12 flex flex-wrap items-center gap-4">
          <a
            href={`tel:${restaurant.phoneRaw}`}
            data-testid="hero-call-cta"
            className="lift inline-flex items-center gap-3 bg-[#d98a6c] hover:bg-[#b86a4d] text-[#f9f6f0] px-7 py-4 text-sm tracking-[0.18em] uppercase"
          >
            <Phone className="h-4 w-4" strokeWidth={1.6} />
            Book a Table
          </a>
          <a
            href="#menu"
            data-testid="hero-menu-cta"
            className="lift inline-flex items-center gap-3 border border-[#f9f6f0]/40 hover:bg-[#f9f6f0] hover:text-[#2c3528] text-[#f9f6f0] px-7 py-4 text-sm tracking-[0.18em] uppercase backdrop-blur"
          >
            See the Menu
          </a>
        </div>

        {/* Footer info */}
        <div className="mt-20 md:mt-28 grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-[#f9f6f0]/20 pt-8 text-[#f9f6f0]/85">
          <div>
            <p className="overline text-[#e8d8b8]">Address</p>
            <p className="mt-2 text-sm flex items-start gap-2">
              <MapPin className="h-4 w-4 mt-0.5" strokeWidth={1.5} />
              Tsilivi, Planos 291 00
            </p>
          </div>
          <div>
            <p className="overline text-[#e8d8b8]">Heritage</p>
            <p className="mt-2 text-sm">15 years · Family-owned</p>
          </div>
          <div>
            <p className="overline text-[#e8d8b8]">Speciality</p>
            <p className="mt-2 text-sm italic font-serif-display text-lg leading-none">
              Lamb Kleftiko
            </p>
          </div>
          <div>
            <p className="overline text-[#e8d8b8]">Call us</p>
            <a
              href={`tel:${restaurant.phoneRaw}`}
              className="mt-2 text-sm hover:text-white block"
              data-testid="hero-footer-phone"
            >
              697 683 5281
            </a>
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 text-[#f9f6f0]/70 text-[10px] tracking-[0.4em] uppercase">
        <span className="block w-px h-10 bg-[#f9f6f0]/40 mx-auto mb-2 animate-pulse" />
        Scroll
      </div>
    </section>
  );
};
